import './../../App.css'
import ModalForm from '../common/modalForm.js'
import { userBALService } from '../../bal/user.bal.js'
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import ToastMessage from "../deals/components/toastMessage.js";
import { Prompt } from "react-router-dom";
import { procurementDetailBALService } from '../../bal/procurementDetail.bal.js';
import moment from 'moment';
import { Dropdown } from 'semantic-ui-react'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faSave, faHome } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import history from '../../history/history.js';
import JoditEditor from "jodit-react";
import { dealBALService } from '../../bal/deal.bal.js';
import { Utils } from '../../helper/utils.js';
import NumberFormat from 'react-number-format';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import ProcurementAllocation from './procurementAllocation.js'

import { s3BALService } from '../../bal/s3.bal.js';
import fileDownload from 'js-file-download'

class ProcurementAdd extends Component {
    constructor(props) {
        super(props);
        this.mounted = false;
        this.timeout = 250;

        const procurementDetail = this.props?.location?.state?.data;
        const gridData = this.props?.location?.state?.gridData;

        this.homePath = '/procurementDashboard';
        this.state = {
            ...userBALService.getUserDetails(),
            gridData : gridData,
            modalVisible: false,
            modalType: 'close',
            modalHeading: '',
            modalHandler: '',
            errorList: [],
            messageHeader: "",
            showMessage: false,
            entityList: null,
            categoryList: null,
            subCategoryList: null,
            departmentList: null,
            userList: null,
            userListAll: null,
            userListActive: null,
            showOnlyActiveUsers: false,
            currencyList: null,
            exchangeRateList:null,
            saveCaption: procurementDetail?.procurementDetailId ? 'Save' : 'Add Attachments',
            fundEntityList:[],
            nestedGridData: [],
            paymentTermList: [{ key: 'Monthly', value: 'Monthly', text: 'Monthly' }, { key: 'Quarterly', value: 'Quarterly', text: 'Quarterly' }, { key: 'Semi-Annual', value: 'Semi-Annual', text: 'Semi-Annual' }, { key: 'Annual', value: 'Annual', text: 'Annual' }, { key: 'Other', value: 'Other', text: 'Other' }],
            terminationNoticeTermsList: Array.from({ length: 365 }, (_, i) => ({ key: i + 1, value: i + 1, text: `${i + 1} ${i === 0 ? 'day' : 'days'}` })),
            files: null,
            existingProcurementDetail : procurementDetail ?? {
                procurementDetailId: null,
                procurementAllocation:null,
                newOrRenewal: null,
                categoryId: null,
                subCategoryId: null,
                subCategoryText: null,
                entityId: null,
                departmentId: null,
                departmentHeadId: null,
                vendorName: null,
                vendorServiceName: null,
                vendorRelationshipManager: null,
                vendorPhone: null,
                vendorEmail: null,
                outsourcing: null,
                aiPolicyCompliant: null,
                scopeOfServices: null,
                objectives: null,
                source: null,
                contractTerm: null,
                contractStartDate: null,
                contractEndDate: null,
                currency: null,
                annualCost: null,
                annualCostUSD: null,
                paymentTermSelected: null,
                paymentTerm: null,
                terminationNoticeTerms: null,
                chargeTerms: null,
                requestorPrimaryId: null,
                requestorSecondaryId: null,
                userSelected: null,
                nonStandardTerms: null,
                documentRetention: null,
                departmentHeadApproved: null,
                seniorManagementApproved: null,
                renewalTerms: null,
                renewalTermsPricing: null,
                annualDDcompleted: null,
                live: null,
                engagementLetterSigned: null,
                dateRequested:null,
                dateDepartmentHeadApproved: null,
                dateSeniorManagementApproved: null,
                dateFullyApproved:null,
                showOnlyActiveUsers:false,
                comments: '',
                autoRenewed: null,
                managementSignedOff: null,
                multipleYearContract: null,
                multipleYearContractPriceValidation:null,
                status: 'Approved'
            },
            newProcurementDetail : procurementDetail ?? {
                procurementDetailId: null,
                procurementAllocation:null,
                newOrRenewal: null,
                categoryId: null,
                subCategoryId: null,
                subCategoryText: null,
                entityId: null,
                departmentId: null,
                departmentHeadId: null,
                vendorName: null,
                vendorServiceName: null,
                vendorRelationshipManager: null,
                vendorPhone: null,
                vendorEmail: null,
                outsourcing: null,
                aiPolicyCompliant: null,
                scopeOfServices: null,
                objectives: null,
                source: null,
                contractTerm: null,
                contractStartDate: null,
                contractEndDate: null,
                currency: null,
                annualCost: null,
                annualCostUSD: null,
                paymentTermSelected: null,
                paymentTerm: null,
                terminationNoticeTerms: null,
                chargeTerms: null,
                requestorPrimaryId: null,
                requestorSecondaryId: null,
                userSelected: null,
                nonStandardTerms: null,
                documentRetention: null,
                departmentHeadApproved: null,
                seniorManagementApproved: null,
                renewalTerms: null,
                renewalTermsPricing: null,
                annualDDcompleted: null,
                live: null,
                engagementLetterSigned: null,
                dateRequested:null,
                dateDepartmentHeadApproved: null,
                dateSeniorManagementApproved: null,
                dateFullyApproved:null,
                showOnlyActiveUsers:false,
                comments: '',
                autoRenewed: null,
                managementSignedOff: null,
                multipleYearContract: null,
                multipleYearContractPriceValidation:null,
                status: 'Approved'
            },
            joditConfig: {
                readonly: false // all options from https://xdsoft.net/jodit/doc/,
            }
        };
        this.render = this.render.bind(this);
        this.closeMessage = this.closeMessage.bind(this);
        this.getPage = this.getPage.bind(this);
        this.save = this.save.bind(this);
        this.handleDropDownChange = this.handleDropDownChange.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleChangeNew = this.handleChangeNew.bind(this);
        this.handleDropDownChangeCategory = this.handleDropDownChangeCategory.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleHome = this.handleHome.bind(this);
        this.handleModalChange = this.handleModalChange.bind(this);
        this.goHome = this.goHome.bind(this);
        this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
        this.handleChangeCheckboxShowOnlyActiveUsers = this.handleChangeCheckboxShowOnlyActiveUsers.bind(this);
        this.handleChangeTextBox = this.handleChangeTextBox.bind(this);
        this.loadCurrency = this.loadCurrency.bind(this);
        this.getFormatted = this.getFormatted.bind(this);
        this.setFile = this.setFile.bind(this);
        this.upload = this.upload.bind(this);
        this.getS3Path = this.getS3Path.bind(this);
        this.getFiles = this.getFiles.bind(this);
        this.download = this.download.bind(this);
        this.remove = this.remove.bind(this);
        this.handleChangeNewAnnualCost = this.handleChangeNewAnnualCost.bind(this);    
        this.getNestedGridData = this.getNestedGridData.bind(this);
        this.handleNestedGridDataChange = this.handleNestedGridDataChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        
        this.populateDropDownLists(procurementDetail);

    }

    // Method 1: Real-time data updates via callback
    handleNestedGridDataChange = (data) => {
        //console.log('Data updated in nested grid:', data);
        this.setState({ newProcurementDetail: { ...this.state.newProcurementDetail, ['procurementAllocation']: data  } });
        // You can perform additional operations here
        // like validation, saving to database, etc.
    };

    // Method 2: Get data on demand via ref
    getNestedGridData = () => {
        if (this.state.childRef) {
            const data = this.state.childRef.getData();
            console.log('Current nested grid data:', data);
            return data;
        }
        return [];
    };

    // Method 3```cific events (save, submit, etc.)
    handleSave = () => {
        const currentData = this.getNestedGridData();
        
        // Validate data
        const isValid = this.validateNestedGridData(currentData);
        
        if (isValid) {
            // Process the data (save to API, etc.)
            this.saveDataToAPI(currentData);
        } else {
            alert('Please fill in all required fields');
        }
    };

    // Validation method
    validateNestedGridData = (data) => {
        for (let dateRange of data) {
            if (!dateRange.startDate || !dateRange.endDate) {
                return false;
            }
            for (let row of dateRange.rows) {
                if (!row.fundEntityId || !row.allocationPercentage) {
                    return false;
                }
            }
        }
        return true;
    };

    getFormatted = (value) =>  {
        return value && !isNaN(value) && parseFloat(value) ? parseFloat(value).toFixed( Number.isInteger(value) ? 0 : 2) : value;
    }

    loadCurrency() {
        dealBALService.getRates().then(data => {
            const currencyList = data.map(item => { return { key: item.Currency, value: item.Currency, text: item.Currency } });
            this.setState({ currencyList: currencyList }); 
            this.setState({ exchangeRateList: data }); 
        }, error => { console.log(error); });
    }

    handleModalChange() {
        if (this.state.modalHandler === 'refresh') {
           this.setState({isOpenGrid: true, modalVisible: false});
        } else if (this.state.modalHandler === 'save') {
            this.save(null, false);
            this.setState({isOpenGrid: true, modalVisible: false});
        } else {
            this.setState({isOpenGrid: true, modalVisible: false});
        }
    }

    goHome() {
        history.push(this.homePath);
        window.location.pathname = this.homePath;
    }

    handleHome() {
        const { existingProcurementDetail, newProcurementDetail } = this.state;
        if(JSON.stringify(existingProcurementDetail) !== JSON.stringify(newProcurementDetail)) {
            this.setState({
                modalVisible: true,
                modalType: 'saveChanges',
                modalHandler: 'discard',
                modalHeading: 'Do you want to discard changes?'
            })
        } else {
            this.goHome();
        }
    }

    render() {
        if (this.state.redirectTo)
            return <Redirect to={this.state.redirectTo} />;
        return this.getPage();
    }

    closeModal() {
        if (this.state.modalHandler === 'refresh') {
            window.location.reload();
        }
        this.setState({
            modalVisible: false
        });
    }

    closeMessage() {
        this.setState({ showMessage: false, errorList: [], messageHeader: "" });
    }
    
    save(e, isSendForApproval=false) {
        const { saveCaption, newProcurementDetail, existingProcurementDetail, files } = this.state;
        const { procurementDetailId, subCategoryText, newOrRenewal, categoryId, subCategoryId, entityId, departmentId, departmentHeadName, departmentHeadId, vendorName, vendorRelationshipManager, vendorPhone, vendorEmail, outsourcing, aiPolicyCompliant, scopeOfServices, objectives, source, contractTerm, contractStartDate, contractEndDate, currency, annualCost, annualCostUSD, paymentTerm, terminationNoticeTerms, chargeTerms, requestorPrimaryId, requestorSecondaryId, nonStandardTerms, documentRetention, departmentHeadApproved, seniorManagementApproved, vendorServiceName, renewalTerms, renewalTermsPricing,annualDDcompleted,live,engagementLetterSigned,dateRequested,dateDepartmentHeadApproved,dateSeniorManagementApproved, dateFullyApproved } = newProcurementDetail;
        var isAddAttachments = false;
        let errorList = [];
        if (JSON.stringify(existingProcurementDetail) === JSON.stringify(newProcurementDetail) && newProcurementDetail.procurementDetailId !== null) {
            errorList.push('No changes to save!');
            this.setState({
                showMessage: true, 
                errorList: errorList, 
                messageHeader : "",
                modalVisible: false,
                modalType: 'close',
                modalHandler: 'close',
                modalHeading: 'No Changes to Save:',
                open: false,
                deal:null,
            } ); 
        } else {
            if(saveCaption === 'Add Attachments') {
                isAddAttachments = true;
            }
            else if(files?.length === 0) {
                errorList.push('Attaching Engagement Letter is mandatory!');
            }

            const {status} = newProcurementDetail;
            if(((isSendForApproval && status && status !=='Draft') || !isSendForApproval) && JSON.stringify(existingProcurementDetail) === JSON.stringify(newProcurementDetail)) {
                this.setState({
                    modalVisible: true,
                    modalType: 'close',
                    modalHandler: 'save',
                    modalHeading: 'No changes to save or submit for approval!',
                })
            }
            /*
            newProcurementDetail : procurementDetail ?? {
                    procurementDetailId: null,
                    procurementAllocation:null,
                    newOrRenewal: null,
                    categoryId: null,
                    subCategoryId: null,
                    entityId: null,
                    departmentId: null,
                    departmentHeadId: null,
                    vendorName: null,
                    vendorServiceName: null,
                    vendorRelationshipManager: null,
                    vendorPhone: null,
                    vendorEmail: null,
                    outsourcing: null,
                    aiPolicyCompliant: null,
                    scopeOfServices: null,
                    objectives: null,
                    source: null,
                    contractTerm: null,
                    contractStartDate: null,
                    contractEndDate: null,
                    currency: null,
                    annualCost: null,
                    annualCostUSD: null,
                    paymentTermSelected: null,
                    paymentTerm: null,
                    terminationNoticeTerms: null,
                    chargeTerms: null,
                    requestorPrimaryId: null,
                    requestorSecondaryId: null,
                    userSelected: null,
                    nonStandardTerms: null,
                    documentRetention: null,
                    departmentHeadApproved: null,
                    seniorManagementApproved: null,
                    renewalTerms: null,
                    renewalTermsPricing: null,
                    annualDDcompleted: null,
                    live: null,
                    engagementLetterSigned: null,
                    dateRequested:null,
                    dateDepartmentHeadApproved: null,
                    dateSeniorManagementApproved: null,
                    dateFullyApproved:null,
                    showOnlyActiveUsers:false,
                    comments: ''
            */

            const {subCategoryId, categoryId, vendorName, vendorServiceName, entityId, departmentId} = newProcurementDetail;
            if(categoryId === null || categoryId <=0) {
                errorList.push('Category is mandatory!');
            }
           
            var text = this.state.categoryList?.filter(p=>p.value === categoryId)[0]?.text;
            const isOthersCategory = text?.toLowerCase() === 'others';

            console.log('isOthersCategory:', isOthersCategory);
            console.log('subCategoryId:', subCategoryId);
            if((!isOthersCategory && (subCategoryId === null || subCategoryId <= 0)) || (isOthersCategory && (subCategoryText === null || subCategoryText?.trim() === ''))) {
                errorList.push('Sub category is mandatory!');
            }

            if(vendorName === null || vendorName.trim() === ''){
                errorList.push('Vendor Name is mandatory!');
            }

            if(vendorServiceName === null || vendorServiceName.trim() === '') {
                errorList.push('Vendor Service Name is mandatory!');
            }
            /*
            if(gridData.filter(p=> p.name?.toUpperCase() === name?.toUpperCase() && p.entityId === entityId  && p.id !== newProcurementDetail?.id ).length>0 ) {
                errorList.push('Duplicate name/entity combination, please enter another name/entity!');
            }
            if(frequencyId === null) {
                errorList.push('Frequency is mandatory!');
            }
            if(hardDeadlineMonths === null) {
                errorList.push('Hard Deadline Months is mandatory!');
            }
            if(hardDeadlineDays === null) {
                errorList.push('Hard Deadline Days is mandatory!');
            }
            if(hasSoftDeadline && softDeadlineDays === null) {
                errorList.push('Soft Deadline Days is mandatory when Soft deadline is selected!');
            }
            if(hasSoftDeadline && softDeadlineMonths === null) {
                errorList.push('Soft Deadline Months is mandatory when Soft deadline is selected!');
            }
            if(entityId === null) {
                errorList.push('Entity is mandatory!');
            }
            if(jurisdictionId === null) {
                errorList.push('Jurisdiction is mandatory!');
            }
            if(primaryUserId === null) {
                errorList.push('Primary Person is mandatory!');
            }
            if(secondaryUserId === null) {
                errorList.push('Secondary Person is mandatory!');
            }*/

            if(errorList.length > 0) {
                this.setState({
                    showMessage: true, 
                    errorList: errorList, 
                    messageHeader : "Please correct the following errors before saving:",
                    modalVisible: false,
                    modalType: 'close',
                    modalHandler: 'close',
                    modalHeading: 'Errors:',
                    open: false,
                    deal:null,
                } );  
            }
            else {
                var userOfService = newProcurementDetail.userOfService;
                procurementDetailBALService.save({...newProcurementDetail, 'submitted': isSendForApproval}).then( 
                    data => {
                        data = {...data, status: 'Approved', userOfService:userOfService};
                        console.log('Saved data successfully!');
                        this.setState({
                            newProcurementDetail: data,
                            existingProcurementDetail: data,
                            saveCaption: 'Save',
                            showMessage: false, 
                            errorList: null, 
                            messageHeader : "",
                            modalVisible: true,
                            modalType: 'close',
                            modalHandler: 'close',
                            modalHeading: isAddAttachments ? 'You may add attachments now!' : 'Data has been saved successfully!',
                            open: false,
                            deal:null
                        } ); 
                    } 
                    , error => {
                        this.setState({ 
                            showMessage: true, 
                            errorList: [error], 
                            messageHeader : `Error while saving Procurement:`,
                            modalVisible: true,
                            modalType: 'close',
                            modalHandler: 'close',
                            modalHeading: 'Saving data failed!'
                        }); 
                        console.log(error);
                });
            }
        }
    }  
    download(fileFullPath, fileName) {
        s3BALService.downloadFile(fileFullPath).then(data => {
            fileDownload(data, fileName.substring(fileName.indexOf('_') + 1));
        }, error => {
            this.setState({
                showMessage: true, 
                errorList: [error], 
                messageHeader : "Error while downloading the attached file:",
                modalVisible: true,
                modalType: 'close',
                modalHandler: 'save',
                modalHeading: 'Attached file could not be downloaded, please contact support!'
            });
        });
    }

    remove(fileFullPath, fileName) { 
        s3BALService.deleteFile({fileName : fileFullPath, type: 'procurement'}).then(data => {
            this.getFiles();
        }, error => {
            this.setState({ 
                showMessage: true, 
                errorList: [error], 
                messageHeader : "Error while removing the attached file:",
                modalVisible: true,
                modalType: 'close',
                modalHandler: 'save',
                modalHeading: 'Attached file could not be removed, please contact support!'
            });
        });
    }
    
    getFiles = async () => {
        await s3BALService.getFiles({ path: this.getS3Path().replace(/~/g, '/') }).then(data => {
            this.setState({files : data.files});
        });
    }

    getS3Path() {
        const { newProcurementDetail } = this.state;
        return `procurement~${newProcurementDetail.procurementDetailId}`;
    }

    upload(e) {
        const { file, fy, userId} = this.state;
        if(file) {
            const path = this.getS3Path();
            s3BALService.uploadFile({file: file, fy: fy, userId:userId, path: path }).then(data => {
                    this.setState({
                        showMessage: false, 
                        file: null,
                        errorList: null, 
                        messageHeader : "",
                        modalVisible: true,
                        modalType: 'close',
                        modalHandler: 'close',
                        modalHeading: 'File uploaded successfully!',
                        open: false
                    });
                    this.getFiles();
                }, error => {
                    this.setState({ 
                        showMessage: true, 
                        errorList: [error], 
                        messageHeader : "Error while uploading the data :",
                        modalVisible: true,
                        modalType: 'close',
                        modalHandler: 'save',
                        modalHeading: 'File could not be uploaded, please contact support!'
                    });
                }
            );
        }
    }

    setFile(e) {    
        this.setState({
            file: e.target.files[0]
        });
    }       

    populateDropDownLists(procurementDetail) {
        this.getFiles()    
        dealBALService.getAllSettings().then(data => {
                this.setState({ settingList: data});
            const entityList = Utils.getSettingByName(data, "TaskEntity").filter(item => item.value !== 'N/A') .map(item => { return { key: item.value, value: item.id, text: item.value } });
            const fundEntityList = Utils.getSettingByName(data, "ProcurementFundEntity").map(item => { return { key: item.value, value: item.id, text: item.value } });
            
            const departmentList = Utils.getSettingByName(data, "Department").map(item => { return { key: item.value, value: item.id, text: item.value } });
            const categoryList = Utils.getSettingByName(data, "ProcurementCategory").map(item => { return { key: item.value, value: item.id, text: item.value } });

            userBALService.getAll().then(users=> {
                //userList
                const userList = users.filter(p=>p.name !== 'test test' && p.name !== 'Tor').map(item => { return { key: item.name, value: item.id, text: item.name } });
                console.log('userList in procurementAdd:', users);

                // After dropdowns and procurementDetail are loaded, set sub-category state correctly
                //procurementDetail = this.props?.location?.state?.data;
                var subCategoryList = [];
                var subCategoryId = null;
                var subCategoryText = null;
                var isOthersCategory = 0;
                if (procurementDetail && procurementDetail.categoryId && categoryList) {
                    const categoryObj = categoryList.find(p => p.value === procurementDetail.categoryId);
                    isOthersCategory = categoryObj && categoryObj.text?.toLowerCase() === 'others';                    
                    if (isOthersCategory) {
                        subCategoryText = procurementDetail.subCategoryText || '';
                    } else {
                        // Not 'Others': populate subCategoryList and set subCategoryId
                        subCategoryList = Utils.getSettingByName(this.state.settingList, `ProcurementSubCategory:${categoryObj.text}`)
                            .map(item => ({ key: item.value, value: item.id, text: item.value }));
                        subCategoryId = procurementDetail.subCategoryId || null;
                    }
                }


                this.setState({
                    userListActive: users.filter(p=>p.current && p.name !== 'test test' && p.name !== 'Tor').map(item => { return { key: item.name, value: item.id, text: item.name } }),
                    userListAll: userList,
                    userList: userList,
                    settingList: data,
                    entityList: entityList,
                    categoryList: categoryList,
                    subCategoryList:subCategoryList,
                    departmentList: departmentList,
                    fundEntityList: fundEntityList,
                     newProcurementDetail: {
                        ...this.state.newProcurementDetail,
                        subCategoryId: procurementDetail?.subCategoryId || null,
                        subCategoryText: subCategoryText,
                        isOthersCategory: isOthersCategory
                    },
                    isOthersCategory: isOthersCategory
                }, () => {
                    const { newProcurementDetail } = this.state;
                    if(newProcurementDetail?.categoryId!==null) {
                        //this.handleDropDownChangeCategory(null, { name: 'categoryId', value: newProcurementDetail?.categoryId });
                    }
                }
            );
            });

        }, error => { console.log(error); });
        this.loadCurrency();
    }

    handleDropDownChange(e, { name, value}) {
        this.handleChangeNew(name, value);
    }

    handleDropDownChangeCategory(e, { name, value}) {
        console.log(e);

        if(value === null || value <=0) {
            this.setState({
                subCategoryList: [],
                newProcurementDetail: { ...this.state.newProcurementDetail, 'subCategoryId': null, [name]: value}
            });
        } else {
            var text = this.state.categoryList?.filter(p=>p.value === value)[0]?.text;
            console.log(text);
            const isOthersCategory = text?.toLowerCase() === 'others';
            const subCategoryList = Utils.getSettingByName(this.state.settingList, `ProcurementSubCategory:${text}`).map(item => { return { key: item.value, value: item.id, text: item.value } });

            this.setState({
                subCategoryList: isOthersCategory ? [] : subCategoryList,            
                isOthersCategory: isOthersCategory,
                newProcurementDetail: { ...this.state.newProcurementDetail, 'subCategoryId': null, [name]: value}
            });
        }
    }
    handleChangeNewAnnualCost(name, value) {
        const { exchangeRateList, newProcurementDetail } = this.state;
        const selectedCurrency = newProcurementDetail.currency;
        const exchangeRateObj = exchangeRateList?.find(p=> p.Currency === selectedCurrency);
        const exchangeRate = exchangeRateObj ? exchangeRateObj.Rate : 1;
        this.setState({ newProcurementDetail: { ...this.state.newProcurementDetail, [name]: value
            , annualCostUSD: value ? value / exchangeRate : null }
        });
    }

    handleChangeNew(name, value) {
        //
        //console.log('handleChangeNew', name, value)
        this.setState({ newProcurementDetail: { ...this.state.newProcurementDetail, [name]: value  }
        });
    }

    handleChangeTextBox(e) {
        const { name, value } = e.target; 
        this.handleChangeNew(name, value);
    }

    handleChangeCheckbox(e) {
        this.setState({
            newProcurementDetail: {
                ...this.state.newProcurementDetail,
                [e.target.name]: e.target.value === "true"
            }
        });
    }

    handleChangeCheckboxShowOnlyActiveUsers(e) {
        const newValue = e.target.value === "true";
        this.setState({
            newProcurementDetail: {
                ...this.state.newProcurementDetail,
                [e.target.name]: newValue
            },
            userList: newValue ? this.state.userListActive : this.state.userListAll 
        });
        this.setState({ 
            showOnlyActiveUsers: e.target.checked,

        });
    }

    handleChange(name, value) {
        this.setState({ [name]: value });
    }
    
    getPage() {
        const { saveCaption, isApprover, files, fundEntityList, paymentTermList, terminationNoticeTermsList, entityList, categoryList, subCategoryList, departmentList, joditConfig, userList, currencyList, newProcurementDetail, existingProcurementDetail, modalType, modalVisible, modalHeading, isOthersCategory } = this.state;
        const { autoRenewed, managementSignedOff, multipleYearContract, multipleYearContractPriceValidation, comments, status, procurementAllocation, showOnlyActiveUsers, procurementDetailId, paymentTermSelected, userOfService, newOrRenewal, categoryId, subCategoryId, subCategoryText, entityId, departmentId, departmentHeadName, departmentHeadId, vendorName, vendorServiceName, vendorRelationshipManager, vendorPhone, vendorEmail, outsourcing, aiPolicyCompliant, scopeOfServices, objectives, source, contractTerm, contractStartDate, contractEndDate, currency, annualCost, annualCostUSD, paymentTerm, terminationNoticeTerms, chargeTerms, requestorPrimaryId, requestorSecondaryId, nonStandardTerms, documentRetention, departmentHeadApproved, seniorManagementApproved, renewalTerms, renewalTermsPricing, annualDDcompleted, live, engagementLetterSigned, dateRequested, dateDepartmentHeadApproved, dateSeniorManagementApproved, dateFullyApproved } = newProcurementDetail;
        //console.log('fundEntityList in procurementAdd:', fundEntityList);
        const contractTermCaption = contractStartDate && contractEndDate ? Utils.dateDifferenceDay(contractStartDate, contractEndDate) : '';
        console.log('contractTermCaption:', contractTermCaption);
        return (
            <div style={{ gridTemplateRows: 'auto auto 1fr', display: 'grid', height: '100%', width: '100%' }} >
                {
                    this.state.showMessage ?
                        <ToastMessage
                            header={this.state.messageHeader}
                            errorList={this.state.errorList}
                            closeMessage={this.closeMessage}
                        /> : <div></div>
                }  
                <div style={{ gridTemplateRows: 'auto auto 1fr', display: 'grid', height: '100%', width: '100%', overflowY:'scroll' }} >
                    <div>
                        <div style={{ float: "left", paddingLeft: "15px", cursor: "pointer" }} onClick={this.handleHome}><FontAwesomeIcon icon={faHome} /></div>
                        <span style={{ float: "left", paddingLeft: "20px" }}><h4><u>{procurementDetailId === null ? 'New ' : `Edit `} Procurement (Existing)</u></h4></span>
                         {//<span><h4>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{status !== null ? `Status: ${status}` : ''}</h4></span>-->
                         }
                    </div> 
                    <div style={{ overflow: 'auto', paddingTop:'15px'}}> 

                        <div className="dealForm"> 
                            <div className="row" style={{ padding:'10px 0px 10px 0px'}}>
                                <div className="col" >
                                    <div className="form-control border-none" onChange={this.handleChangeCheckbox}>
                                        <label for='new_Or_Renewal' title='Whether new or renewal Procurement?' className="fsBig"><b>Procurement&nbsp;</b><br/></label><br/>
                                        <input disabled={isApprover} type="radio" id='new_Or_Renewal'  value={true} name='newOrRenewal' checked={newOrRenewal === true} /> <label for='new_Or_Renewal' className="fsBig"><b>New</b></label>&nbsp;&nbsp;&nbsp;
                                        <input disabled={isApprover} type="radio" id='new_Or_Renewal_false' value={false} name='newOrRenewal' checked={newOrRenewal === false} /><label for='new_Or_Renewal_false' className="fsBig"><b>&nbsp;Renewal</b></label>
                                    </div>  
                                </div>
                                <div className="col">
                                    <div className="form-control border-none" onChange={this.handleChangeCheckbox}>
                                        <label for='managementSignedOff' title="Has Management Signed-off" className="fsBig"><b>Management Signed-off</b></label><br/>
                                        <input disabled={isApprover} type="radio" id='managementSignedOff'  value={true} name='managementSignedOff' checked={managementSignedOff === true} /> <label for='managementSignedOff' className="fsBig"><b>Yes</b></label>&nbsp;&nbsp;&nbsp;
                                        <input disabled={isApprover} type="radio" id='managementSignedOff_false' value={false} name='managementSignedOff' checked={managementSignedOff === false} /><label for='managementSignedOff_false' className="fsBig"><b>&nbsp;No</b></label>
                                    </div>
                                </div>
                                <div title='Please select the category below.' className="col">
                                    <label for='categoryId' title='Please select the category below.' className="fsBig"><b>Category:</b></label>
                                    <Dropdown
                                        placeholder='Select Category'
                                        name='categoryId'
                                        width="200px"
                                        fluid
                                        search
                                        selection
                                        clearable
                                        onChange={this.handleDropDownChangeCategory}
                                        options={categoryList}
                                        value={categoryId}
                                    />
                                </div>
                                <div title='Please select the sub-category below.' className="col">
                                    <label for='subCategoryId' title='Please select the sub-category below.' className="fsBig"><b>Sub-Category:</b></label>
                                    {isOthersCategory ? (
                                        <input 
                                            type="text"
                                            placeholder="Enter Sub-Category"
                                            name="subCategoryText"
                                            autoComplete="off"
                                            value={subCategoryText || ''}
                                            className={'form-control inputLightP'}
                                            onChange={this.handleChangeTextBox}
                                        />
                                    ) : (
                                        <Dropdown
                                            placeholder='Select Sub-Category'
                                            name='subCategoryId'
                                            width="200px"
                                            fluid
                                            search
                                            selection
                                            clearable
                                            onChange={this.handleDropDownChange}
                                            options={subCategoryList}
                                            value={subCategoryId}
                                        />
                                    )}
                                </div>
                                <div className="col">                                    
                                    <label for='entityId' title='Please select the Tor entity that is engaging the vendor.' className="fsBig"><b>Tor engaging entity:</b></label>
                                    <Dropdown
                                        placeholder='Select Entity'
                                        name='entityId'
                                        width="200px"
                                        fluid
                                        search
                                        selection
                                        clearable
                                        onChange={this.handleDropDownChange}
                                        options={entityList}
                                        value={entityId}
                                    />
                                </div>
                                <div className="col">
                                    <label for='departmentId' title='Please select the department within the Tor entity that is engaging the vendor.' className="fsBig"><b>Department:</b></label>
                                    <Dropdown
                                        placeholder='Select Department'
                                        name='departmentId'
                                        width="200px"
                                        fluid
                                        search
                                        selection
                                        clearable
                                        onChange={this.handleDropDownChange}
                                        options={departmentList}
                                        value={departmentId}
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ padding:'10px 0px 10px 0px'}}> 
                                <div className="col">
                                    <div className="form-control border-none" onChange={this.handleChangeCheckbox}>
                                        <label for='outsourcing' title="Will the engagement be auto-renewed unless terminated via notice?" className="fsBig"><b>Will the engagement be auto-renewed unless terminated via notice?</b></label><br/>
                                        <input disabled={isApprover} type="radio" id='autoRenewed'  value={true} name='autoRenewed' checked={autoRenewed === true} /> <label for='autoRenewed' className="fsBig"><b>Yes</b></label>&nbsp;&nbsp;&nbsp;
                                        <input disabled={isApprover} type="radio" id='autoRenewed_false' value={false} name='autoRenewed' checked={autoRenewed === false} /><label for='autoRenewed_false' className="fsBig"><b>&nbsp;No</b></label>
                                    </div>
                                </div>
                                <div className="col">
                                    <label for='vendorName' title="Please update the name of full legal name of the vendor." className="fsBig"><b>Vendor's Name</b></label>
                                    <input type="text"
                                        placeholder="Vendor's Name"
                                        name="vendorName"
                                        autoComplete="off"
                                        value={vendorName}
                                        className={'form-control inputLightP'}
                                        onChange={this.handleChangeTextBox}
                                    />
                                </div>
                                <div className="col">
                                    <label for='vendorServiceName' title="Please update the short name of the vendor service." className="fsBig"><b>Vendor Service Name (Short Name)</b></label>
                                    <input type="text"
                                        placeholder="Vendor Service Name (Short Name)"
                                        name="vendorServiceName"
                                        autoComplete="off"
                                        value={vendorServiceName}
                                        className={'form-control inputLightP'}
                                        onChange={this.handleChangeTextBox}
                                    />
                                </div> 
                                <div className="col">
                                    <label for='vendorRelationshipManager' title="Please update the name of the vendor's relationship manager." className="fsBig"><b>Vendor's Relationship Manager</b></label>
                                    <input type="text"
                                        placeholder="Vendor's Relationship Manager"
                                        name="vendorRelationshipManager"
                                        autoComplete="off"
                                        value={vendorRelationshipManager}
                                        className={'form-control inputLightP'}
                                        onChange={this.handleChangeTextBox}
                                    />
                                </div> 
                                <div className="col">
                                    <label for='vendorEmail' title="Please update the email address of the vendor." className="fsBig"><b>Vendor's Email</b></label>
                                    <input type="text"
                                        placeholder="Vendor's Email"
                                        name="vendorEmail"
                                        autoComplete="off"
                                        value={vendorEmail}
                                        className={'form-control inputLightP'}
                                        onChange={this.handleChangeTextBox}
                                    />
                                </div> 
                                <div className="col">
                                    <label for='vendorPhone' title="Please update the phone number of the vendor." className="fsBig"><b>Vendor's Phone</b></label>
                                    <input type="text"
                                        placeholder="Vendor's Phone"
                                        name="vendorPhone"
                                        autoComplete="off"
                                        value={vendorPhone}
                                        className={'form-control inputLightP'}
                                        onChange={this.handleChangeTextBox}
                                    />
                                </div> 
                            </div>
                            <div className="row" style={{ padding:'10px 0px 10px 0px'}}>                                
                                <div className="col">
                                    <div className="form-control border-none" onChange={this.handleChangeCheckbox}>
                                        <label for='outsourcing' title="Legal and Compliance teams will determine whether the engagement is an outsourcing of a management company function and whether the engagement is in scope for the company’s AI policy." className="fsBig"><b>Outsourcing Management Function?</b></label><br/>
                                        <input disabled={isApprover} type="radio" id='outsourcing'  value={true} name='outsourcing' checked={outsourcing === true} /> <label for='outsourcing' className="fsBig"><b>Yes</b></label>&nbsp;&nbsp;&nbsp;
                                        <input disabled={isApprover} type="radio" id='outsourcing_false' value={false} name='outsourcing' checked={outsourcing === false} /><label for='outsourcing_false' className="fsBig"><b>&nbsp;No</b></label>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="form-control border-none" onChange={this.handleChangeCheckbox}>
                                        <label for='aiPolicyCompliant' title="Legal and Compliance teams will determine whether the engagement is an outsourcing of a management company function and whether the engagement is in scope for the company’s AI policy." className="fsBig"><b>AI Policy Compliant?</b></label><br/>
                                        <input disabled={isApprover} type="radio" id='aiPolicyCompliant'  value={true} name='aiPolicyCompliant' checked={aiPolicyCompliant === true} /> <label for='aiPolicyCompliant' className="fsBig"><b>Yes</b></label>&nbsp;&nbsp;&nbsp;
                                        <input disabled={isApprover} type="radio" id='aiPolicyCompliant_false' value={false} name='aiPolicyCompliant' checked={aiPolicyCompliant === false} /><label for='aiPolicyCompliant_false' className="fsBig"><b>&nbsp;No</b></label>
                                    </div>
                                </div>
                                <div className="col">
                                    <label for='requestorPrimaryId' title="Update the relevant internal personnel name who is responsible for managing this vendor relationship." className="fsBig"><b>Requestor (Tor Primary relationship manager)</b></label>
                                    <Dropdown
                                        placeholder='Requestor (Tor Primary relationship manager)'
                                        name='requestorPrimaryId'
                                        fluid
                                        search
                                        selection
                                        clearable
                                        onChange={this.handleDropDownChange}
                                        options={userList}
                                        value={requestorPrimaryId}
                                    />
                                </div>
                                <div className="col">
                                    <label for='requestorSecondaryId' title="Update the relevant internal personnel name who is back-up for the primary person managing this vendor relationship." className="fsBig"><b>Requestor (Tor Secondary relationship manager)</b></label>
                                    <Dropdown
                                        placeholder='Requestor (Tor Secondary relationship manager)'
                                        name='requestorSecondaryId'
                                        fluid
                                        search
                                        selection
                                        clearable
                                        onChange={this.handleDropDownChange}
                                        options={userList}
                                        value={requestorSecondaryId}
                                    />
                                </div>
                        </div>
                        <div className="col">
                            <div className="dealForm"> 
                            <div className="row" style={{ padding:'10px 0px 10px 0px'}}>                                
                                    <div className="col">
                                    <label for='showOnlyActiveUsers' title="Update the list of users who utilize this service."  className="fsBig"><b>User of Service</b> - <b>Show only Active ?</b></label>
                                    <div className="form-control border-none" onChange={this.handleChangeCheckboxShowOnlyActiveUsers}>                                        
                                        <input disabled={isApprover} type="radio" id='showOnlyActiveUsers'  value={true} name='showOnlyActiveUsers' checked={showOnlyActiveUsers === true} /> <label for='showOnlyActiveUsers' className="fsBig"><b>Only Active</b></label>&nbsp;&nbsp;&nbsp;
                                        <input disabled={isApprover} type="radio" id='showOnlyActiveUsers_false' value={false} name='showOnlyActiveUsers' checked={showOnlyActiveUsers === false} /><label for='showOnlyActiveUsers_false' className="fsBig"><b>&nbsp;All</b></label>
                                    </div>
                                    <Dropdown
                                        placeholder='Select Users'
                                        name='userOfService'
                                        fluid
                                        multiple
                                        search
                                        selection
                                        clearable
                                        onChange={(e, { name, value }) => this.handleChangeNew(name, value)}
                                        options={userList}
                                        value={userOfService || []}
                                    />
                                </div>
                                </div>
                                </div>
                        </div>
                        <div>

                            <div className="row" style={{ padding:'10px 0px 10px 0px'}}>
                                <div className="col">                                     
                                    <label for='scopeOfServices' title="Please describe the scope of services (refer to the engagment letter)."  className="fsBig"><b>Description of services (scope)</b></label>
                                    <JoditEditor
                                        value={scopeOfServices}
                                        config={joditConfig}
                                        tabIndex={1} // tabIndex of textarea
                                        onBlur={newScopeOfServices => this.setState({ newProcurementDetail : {...this.state.newProcurementDetail, scopeOfServices: newScopeOfServices} })} // preferred to use only this option to update the content for performance reasons

                                        askBeforePasteHTML={false}
                                        askBeforePasteFromWord={false}
                                        defaultActionOnPaste="insert_clear_html"
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ padding:'10px 0px 10px 0px'}}>
                                <div className="col">                                    
                                    <label for='contractStartDate' title="Please update the start date of the contract."  className="fsBig"><b>Contract Start Date</b></label>
                                    <DatePicker
                                        name="Contract Start Date"                                        
                                        selected={contractStartDate ? new Date(contractStartDate) : null}
                                        onChange={(date) => { 
                                            this.handleChangeNew('contractStartDate', date ? moment(date).format("YYYY-MM-DD") : null)
                                            }}
                                        autoComplete = "off"
                                        showYearDropdown
                                        showMonthDropdown
                                    />
                                </div>
                                <div className="col">
                                    <label for='contractEndDate' title="Please update the end date of the contract."  className="fsBig"><b>Contract End Date</b></label>
                                    <DatePicker
                                        name="Contract End Date"                                        
                                        selected={contractEndDate ? new Date(contractEndDate) : null}
                                        onChange={(date) => { 
                                            this.handleChangeNew('contractEndDate', date ? moment(date).format("YYYY-MM-DD") : null)
                                            }}
                                        autoComplete = "off"
                                        showYearDropdown
                                        showMonthDropdown
                                    />
                                </div>
                                <div className="col">
                                    <label for='contractTerm' title="Length of the contract auto populated by the platform not need to enter."  className="fsBig"><b>Contract Term </b></label>
                                    <div><p>{contractTermCaption}</p></div>
                                </div>                                
                                <div className="col">
                                    <label for='currency' title="Please select the ccy of the engagement."  className="fsBig"><b>Ccy of engagement</b></label>
                                    <Dropdown
                                        placeholder='Ccy of engagement'
                                        name='currency'
                                        width="200px"
                                        fluid
                                        search
                                        selection
                                        clearable
                                        onChange={this.handleDropDownChange}
                                        options={currencyList}
                                        value={currency}
                                    />
                                </div>
                                <div className="col">
                                    <label for='annualCost' title="Please update the costs of the engagement - should correspond with local ccy of engagement."  className="fsBig"><b>Annual costs {currency ?? "USD"}</b></label>
                                    <NumberFormat
                                        disabled={isApprover} 
                                        placeholder={`Annual costs ${currency ?? "USD"}`}
                                        name='annualCost'
                                        value={this.getFormatted(annualCost)}
                                        thousandSeparator={true}
                                        onValueChange={(values) => { this.handleChangeNewAnnualCost('annualCost', values.floatValue); }}
                                        className={'form-control inputLightP'}
                                    />  
                                </div>
                                <div className="col">
                                    <label for='annualCostUSD' title="Auto-populated by the platform - no need to input."  className="fsBig"><b>Annual costs USD</b></label>
                                    <NumberFormat
                                        disabled={isApprover} 
                                        placeholder="Annual costs USD"
                                        name='annualCostUSD'
                                        value={this.getFormatted(currency === "USD"? annualCost:annualCostUSD)}
                                        thousandSeparator={true}
                                        onValueChange={(values) => { this.handleChangeNew('annualCostUSD', values.floatValue); }}
                                        className={'form-control inputLightP'}
                                    />  
                                </div>
                            </div>
                            <div className="row" style={{ padding:'10px 0px 10px 0px'}}>
                                <div className="col">
                                    <div className="form-control border-none" onChange={this.handleChangeCheckbox}>
                                        <label for='multipleYearContract' title="Multiple year contract?"  className="fsBig"><b>Multiple year contract?</b></label><br/>
                                        <input disabled={isApprover} type="radio" id='multipleYearContract'  value={true} name='multipleYearContract' checked={multipleYearContract === true} /> <label for='multipleYearContract' className="fsBig"><b>Yes</b></label>&nbsp;&nbsp;&nbsp;
                                        <input disabled={isApprover} type="radio" id='multipleYearContract_false' value={false} name='multipleYearContract' checked={multipleYearContract === false} /><label for='multipleYearContract_false' className="fsBig"><b>&nbsp;No</b></label>
                                    </div>
                                </div>
                                <div className="col">
                                    <label for='multipleYearContractPriceValidation' title="Multiple Year Contract Price Validation?"  className="fsBig"><b>Multiple Year Contract Price Validation</b></label>
                                    <input type="text"
                                        placeholder="Multiple Year Contract Price Validation"
                                        name="multipleYearContractPriceValidation"
                                        autoComplete="off"
                                        value={multipleYearContractPriceValidation}
                                        className={'form-control inputLightP'}
                                        onChange={this.handleChangeTextBox}
                                    />
                                </div>  
                                <div className="col">                                    
                                    <label for='paymentTermSelected' title="Please update the payment frequency (i.e., monthly, quarterly, annually, etc)."  className="fsBig"><b>Payment Terms(Monthly/Quarterly/Semi-Annual/Annual)</b></label>
                                    <Dropdown
                                        placeholder='Payment Terms agreed'
                                        name='paymentTermSelected'
                                        width="100px"
                                        fluid
                                        search
                                        selection
                                        clearable
                                        onChange={this.handleDropDownChange}
                                        options={paymentTermList}
                                        value={paymentTermSelected}
                                    />
                                    {
                                        paymentTermSelected === 'Other' ?
                                        <div>
                                        <input type="text"
                                            placeholder="Payment Terms agreed(Monthly/Quarterly/Annual)"
                                            name="paymentTerm"
                                            autoComplete="off"
                                            value={paymentTerm}
                                            className={'form-control inputLightP'}
                                            onChange={this.handleChangeTextBox}
                                        /></div>: null
                                    }
                                </div> 
                                <div className="col">
                                    <label for='terminationNoticeTerms' title="Please update the termination notice period for terminating this engagement."  className="fsBig"><b>Termination - Notice Terms</b></label>
                                    <Dropdown
                                        placeholder='Termination - Notice Terms'
                                        name='terminationNoticeTerms'
                                        width="100px"
                                        fluid
                                        search
                                        selection
                                        clearable
                                        onChange={this.handleDropDownChange}
                                        options={terminationNoticeTermsList}
                                        value={terminationNoticeTerms}
                                    />                     
                                </div> 
                                <div className="col">
                                    <label for='chargeTerms' title="Fixed contract Rate or Floating?"  className="fsBig"><b>Charge Terms</b></label>
                                    <input type="text"
                                        placeholder="Charge Terms"
                                        name="chargeTerms"
                                        autoComplete="off"
                                        value={chargeTerms}
                                        className={'form-control inputLightP'}
                                        onChange={this.handleChangeTextBox}
                                    />
                                </div>  
                                <div className="row" style={{ padding:'10px 0px 10px 0px'}}> 
                                    <div className="col">
                                        <div className="form-control border-none" onChange={this.handleChangeCheckbox}>
                                            <label for='annualDDcompleted' title="Has the annual due diligence been completed?"  className="fsBig"><b>Compliance to complete</b></label><br/>
                                            <input disabled={isApprover} type="radio" id='annualDDcompleted'  value={true} name='annualDDcompleted' checked={annualDDcompleted === true} /> <label for='annualDDcompleted' className="fsBig"><b>Yes</b></label>&nbsp;&nbsp;&nbsp;
                                            <input disabled={isApprover} type="radio" id='annualDDcompleted_false' value={false} name='annualDDcompleted' checked={annualDDcompleted === false} /><label for='annualDDcompleted_false' className="fsBig"><b>&nbsp;No</b></label>
                                        </div>
                                    </div>
                                </div> 
                            </div> 
                            <div className="row" style={{ padding:'10px 0px 10px 0px'}}>
                                <div className="col">
                                    <label for='nonStandardTerms' title="Update the list of non-standard terms agreed."  className="fsBig"><b>Non-standard terms (if any)</b></label>
                                    <JoditEditor
                                        value={nonStandardTerms}
                                        config={joditConfig}
                                        tabIndex={1} // tabIndex of textarea
                                        onBlur={newNonStandardTerms => this.setState({ newProcurementDetail : {...this.state.newProcurementDetail, nonStandardTerms: newNonStandardTerms} })} // preferred to use only this option to update the content for performance reasons
                                        askBeforePasteHTML={false}
                                        askBeforePasteFromWord={false}
                                        defaultActionOnPaste="insert_clear_html"
                                    />
                                </div>
                                <div className="col">
                                    <label for='comments' title="Update comments if any in relation to history of engagement etc."  className="fsBig"><b>Others / Comments</b></label>
                                    <JoditEditor
                                        value={comments}
                                        config={joditConfig}
                                        tabIndex={1} // tabIndex of textarea
                                        onBlur={newComments => this.setState({ newProcurementDetail : {...this.state.newProcurementDetail, comments: newComments} })} // preferred to use only this option to update the content for performance reasons
                                        askBeforePasteHTML={false}
                                        askBeforePasteFromWord={false}
                                        defaultActionOnPaste="insert_clear_html"
                                    />
                                </div>
                            </div>
                            <div className="row" style={{ padding:'10px 0px 10px 0px'}}>
                                <div className="col">
                                    <div className="form-control border-none" onChange={this.handleChangeCheckbox}>
                                        <label for='live' title="Is the engagement live or not?"  className="fsBig"><b>Live?&nbsp;</b><br/></label>
                                        <input disabled={isApprover} type="radio" id='live'  value={true} name='live' checked={live === true} /> <label for='live' className="fsBig"><b>Yes</b></label>&nbsp;&nbsp;&nbsp;
                                        <input disabled={isApprover} type="radio" id='live_false' value={false} name='live' checked={live === false} /><label for='live_false' className="fsBig"><b>&nbsp;No</b></label>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="form-control border-none" onChange={this.handleChangeCheckbox}>
                                        <label for='engagementLetterSigned' title="Do we have a signed engagement letter in place"  className="fsBig"><b>Engagement Letter Signed?&nbsp;</b><br/></label>
                                        <input disabled={isApprover} type="radio" id='engagementLetterSigned'  value={true} name='engagementLetterSigned' checked={engagementLetterSigned === true} /> <label for='engagementLetterSigned' className="fsBig"><b>Yes</b></label>&nbsp;&nbsp;&nbsp;
                                        <input disabled={isApprover} type="radio" id='engagementLetterSigned_false' value={false} name='engagementLetterSigned' checked={engagementLetterSigned === false} /><label for='engagementLetterSigned_false' className="fsBig"><b>&nbsp;No</b></label>
                                    </div>
                                </div>
                            </div>
                        </div>                         
                        </div>
             <div className="parent-container">                
                {/* Display current data summary
                <div className="data-summary">
                    <h3>Current Data Summary:</h3>
                    <p>Total Date Ranges: {this.state.nestedGridData.length}</p>
                    <p>Total Rows: {
                        this.state.nestedGridData.reduce((total, dr) => total + dr.rows.length, 0)
                    }</p>
                </div> */}

                {/* Control buttons */}
                <div className="parent-controls">
               {/* Nested Grid Component */}
                <ProcurementAllocation 
                    fundEntityList={fundEntityList}
                    procurementAllocation={procurementAllocation}
                    onDataChange={this.handleNestedGridDataChange}
                    onRef={(ref) => this.setState({ childRef: ref })}
                />
                </div>
            </div>
                        { (procurementDetailId !=null ) ? 
                        <div style={{  overflowX: 'auto', overflowY: 'auto', height: 'auto', minHeight:'200px', padding:'20px 20px 20px 20px'}}>
                            <div style={{ float: "left", paddingDown: "15px", paddingRight: "7px" }} >
                                You may upload engagement letter which is mandatory and other relevant documents here:
                            </div>
                        <div style={{  overflowX: 'auto', overflowY: 'auto', height: 'auto', minHeight:'200px', padding:'20px 20px 20px 20px'}}>
                            <div style={{ float: "left", paddingDown: "15px", paddingRight: "7px" }} >
                                Select file to upload : <input type="file" onChange={this.setFile} /><br/>
                            </div>
                            <div style={{ float: "left", paddingDown: "15px", paddingRight: "50px" }} onClick={this.upload}>
                                <button key='uploadButton' className="blueB-no-margin">Upload</button> 
                            </div>
                        </div>
                        <div style={{ display: 'grid'}}>
                                {files && files.length > 0 && <div style={{ borderTop:'none', border: '1px solid black', width:"964px", float: "left", paddingRight: "55px"}}><h2>Uploaded Files:</h2></div>}
                                {files &&
                                files.map((file, index) => ( 
                                    <div style={{ height:'43px'}}>
                                        <div style={{borderLeft: '1px solid black', borderBottom: '1px solid black', float: "left",  paddingRight: "15px", width:"600px" }}>
                                            <div style={{ paddingLeft:'5px', width:"500px", height:'42px' }}>
                                                <h3>{file.fileName.substring(file.fileName.indexOf('_') + 1)}</h3>
                                            </div>
                                        </div>
                                        <div style={{ paddingLeft:'5px', paddingTop:'2px', paddingBottom: "2px", height:'100%', borderLeft: '1px solid black', borderBottom: '1px solid black', float: "left", cursor: "pointer" }} onClick={() => this.download(file.fileFullPath, file.fileName)}>
                                            <button key='downloadButton' className="blueB-no-margin">Download</button>
                                        </div>
                                        <div style={{ paddingLeft:'5px', paddingTop:'2px', paddingBottom: "2px", height:'100%', borderRight: '1px solid black', borderLeft: '1px solid black', borderBottom: '1px solid black', float: "left" }} onClick={() => this.remove(file.fileFullPath)}>
                                            <button key='removeButton' className="blueB-no-margin">Remove</button>
                                        </div> 
                                    </div> 
                                ))}
                        </div>
                        </div> : <div></div>
                        }
                    </div>
                            {status !=='In Approval'?
                    <div >
                        <div style={{ float: "right", paddingRight: "30px", cursor: "pointer" }} onClick={this.save}>
                            <button key='saveButton' className="blueB-no-margin">{saveCaption}</button>
                        </div>
                    </div> 
                    :  null }
                    <div> &nbsp;</div> 
                </div>
                <Prompt when={JSON.stringify(existingProcurementDetail) !== JSON.stringify(newProcurementDetail)}
                    message="Do you want to discard changes?"/>
                <ModalForm modalType={modalType}
                    modalVisible={modalVisible}
                    modalHeading={modalHeading}
                    onClickAway={() => this.closeModal()}
                    onClickClose={() => this.closeModal()}
                    onClickYes={() => this.goHome()} />
            </div>
        );
    }
}

export default ProcurementAdd;
